export const InViewLoader = ({
  elements = [{ selector: '', callback: () => {} }],
}) => {
  const createObservedElement = ({ selector, callback }) => ({
    element: document.querySelector(selector),
    callback,
  })

  let observeredElements = elements.map(createObservedElement)

  const addWatcher = (element = { selector: '', callback: () => {} }) => {
    const updatedElements = [observeredElements, createObservedElement(element)]
    observeredElements = updatedElements
  }
  const lookupCallback = ({ target }) => {
    const element = observeredElements.find(({ element }) => target === element)
    return element.callback
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const callback = lookupCallback(entry)
        callback()
        observer.unobserve(entry.target)
      }
    })
  })

  elements.forEach(({ selector }) => {
    const element = document.querySelector(selector)
    observer.observe(element)
  })

  return {
    elements,
    addWatcher,
    observer,
  }
}
